import { PAYMENT_MODE, type PaymentMode } from "@/domain/payment/payment-mode"

/**
 * Website fulfilment method. It is carried on the wire only by the existing `order_type`
 * (backend `OrderType`): there is no separate fulfilment field. `order_source` (Website = 2)
 * and `order_channel` (Website = 2) are independent of it.
 */
export type Fulfilment = "DELIVERY" | "PICKUP"

export const DEFAULT_FULFILMENT: Fulfilment = "DELIVERY"

/** Backend `OrderType.Delivery`. */
export const DELIVERY_ORDER_TYPE = 3
/** Backend `OrderType.TakeAway`, the type Website Pickup is persisted as. */
export const PICKUP_ORDER_TYPE = 2

/**
 * The fulfilment that actually applies. Pickup only when it is selected **and** the restaurant
 * has `website_pickup_enabled`; anything else (disabled, unknown, config not loaded) is Delivery.
 */
export function resolveEffectiveFulfilment(
  selected: Fulfilment | null | undefined,
  pickupEnabled: boolean
): Fulfilment {
  return selected === "PICKUP" && pickupEnabled === true ? "PICKUP" : "DELIVERY"
}

export function orderTypeForFulfilment(fulfilment: Fulfilment): number {
  return fulfilment === "PICKUP" ? PICKUP_ORDER_TYPE : DELIVERY_ORDER_TYPE
}

/** Shown when Pickup was selected but the restaurant no longer offers it. */
export const PICKUP_UNAVAILABLE_MESSAGE =
  "Pickup is no longer available for this restaurant. Choose Delivery to continue."

/** Pickup is prepaid only (the server rejects TakeAway with any other payment timing). */
export function isPaymentModeAllowedForFulfilment(
  fulfilment: Fulfilment,
  paymentMode: PaymentMode
): boolean {
  return fulfilment !== "PICKUP" || paymentMode === PAYMENT_MODE.ONLINE
}
